const totalColumns = [
  {
    label: "Total Marks",
    key: "totalMarks",
  },
  {
    label: "Trust Score",
    key: "trustScore",
  },
  {
    label: "Added On",
    key: "addedOn",
  },
  {
    label: "Attempted On",
    key: "attemptedOn",
  },
  {
    label: "Areas of Improvement",
    key: "areasOfImprovement",
  },
  {
    label: "Strong Areas",
    key: "strongAreas",
  },
];

const initialColumns = [
  {
    label: "Strong Areas",
    key: "strongAreas",
  },
  {
    label: "Total Marks",
    key: "totalMarks",
  },
  {
    label: "Trust Score",
    key: "trustScore",
  },
];

export { totalColumns, initialColumns };
